import React from "react";
import { CheckCircle2Icon, GlobeIcon, LockIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerItems, offerPerks } from "../../data/landing";
export function Offer() {
  const total = offerItems.reduce((s, o) => s + o.value, 0);
  return <section id="offer" className="bg-brand-800 px-4 py-16 sm:py-20" data-id="element-200" data-mp="353zqeutatea3">
      <div className="mx-auto max-w-2xl" data-id="element-201" data-mp="3a56uojw8fvc0">
        <p className="text-center text-xs font-bold uppercase tracking-[0.14em] text-brand-200 sm:text-sm" data-id="element-202" data-mp="3f4a3mffc2lp9">Special launch offer</p>
        <h2 className="mt-2 text-center font-serif text-[1.85rem] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-203" data-mp="3jwbatmxn9m8f">
          Here's everything you'll receive today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-204" data-mp="3swpwineit3cg">
          <img src={images.mockup} alt="Everything included in ECU Decision System" className="w-full bg-brand-50 p-2" data-id="element-205" data-mp="1pdpv2b9k8as" />

          <div className="p-5 sm:p-8" data-id="element-206" data-mp="1klqcgarowpr5">
            <ul className="divide-y divide-brand-100" data-id="element-207" data-mp="1kmrq8n03bqck">
              {offerItems.map(o => <li key={o.label} className="flex items-center justify-between gap-4 py-3.5" data-id="element-208" data-mp="1fl2dn2x7z4md">
                  <span className="flex items-start gap-2 font-semibold text-ink" data-id="element-209" data-mp="1bl1yth67kres">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-210" data-mp="16n0eksx1qm1q" />
                    {o.label}
                  </span>
                  <span className="shrink-0 font-semibold text-muted line-through" data-id="element-211" data-mp="1zamki7tqy2rr">${o.value}</span>
                </li>)}
              <li className="flex items-center justify-between gap-4 py-3.5" data-id="element-212" data-mp="1uicxp0nxhitp">
                <span className="font-bold uppercase text-ink" data-id="element-213" data-mp="1plcqgmfcea10">Total value</span>
                <span className="text-lg font-bold text-bad line-through" data-id="element-214" data-mp="2mzoz16t33fi1">${total}</span>
              </li>
            </ul>

            <div className="mt-4 rounded-2xl bg-brand-50 px-4 py-6 text-center" data-id="element-215" data-mp="2i8ywe1c1lqr1">
              <p className="text-sm font-bold uppercase text-brand-700" data-id="element-216" data-mp="314z0uo0g41c3">Today you get everything for</p>
              <p className="mt-1 font-serif text-7xl font-black leading-none text-brand-800 sm:text-8xl" data-id="element-217" data-mp="3653i4g96h03d">
                $27
              </p>
              <p className="mt-2 text-sm font-semibold text-muted" data-id="element-218" data-mp="2scx2cv9xsv4g">USD · one-time payment</p>
              <p className="mx-auto mt-3 flex max-w-sm items-start justify-center gap-1.5 text-sm text-ink" data-id="element-219" data-mp="2wd7l78itvg0q">
                <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-600" aria-hidden="true" data-id="element-220" data-mp="2idod2fq0o4of" />
                <span data-id="element-221" data-mp="2nfdqg20poufo">
                  <strong data-id="element-222" data-mp="29eb19gef740j">Automatic currency conversion</strong> — you'll pay the equivalent in your local currency.
                </span>
              </p>
            </div>

            <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-223" data-mp="2dg6bxbi8qtqz">
              {offerPerks.map(p => <li key={p} className="rounded-full border border-brand-100 px-3 py-1 text-xs font-bold uppercase text-brand-800" data-id="element-224" data-mp="7ktz2s926vd6">
                  {p}
                </li>)}
            </ul>

            <div className="mt-6 flex justify-center" data-id="element-225" data-mp="1w47rgoi3jj74">
              <ScarcityBar data-id="element-226" data-mp="1s6a31nw5h14s" />
            </div>

            <CTAButton className="mt-6" label="Get ECU Decision System™" data-id="element-227" data-mp="25wdjtzc9g2mu" />
            <p className="mt-3 flex items-center justify-center gap-1.5 text-xs text-muted" data-id="element-228" data-mp="25xoos2hfzgfj">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-229" data-mp="214cbgoi7qw23" />
              Secure checkout · Instant download · 7-day guarantee
            </p>

            <div className="mt-8" data-id="element-230" data-mp="2avzzeffk9uyt">
              <Countdown data-id="element-231" data-mp="2auyku0zc6qcc" />
            </div>
          </div>
        </div>

        <p className="mt-8 text-center text-base leading-relaxed text-brand-100" data-id="element-232" data-mp="2ovhs35vz9sdg">
          You're not paying $27 for another collection of PDFs. You're getting a structured reference system designed to help you
          approach ECU jobs with a clearer process — ready whenever you need it.
        </p>
      </div>
    </section>;
}